import React, { ReactElement } from 'react'
import type { Clip } from '../video_player/VideoPlayer'
import './PreviousClip.scss'

export default function PreviousClipThumbnail({
  currentClip,
  setCurrentClip,
}: {
  currentClip: Clip | null
  setCurrentClip: React.Dispatch<React.SetStateAction<Clip | null>>
}): ReactElement {
  function reloadPreviousClip(): void {
    if (currentClip) setCurrentClip(currentClip.previousClip)
  }

  return (
    <div className="previousClipThumbnail">
      {currentClip && currentClip.previousClip ? (
        <button type="submit" className="previous-btn" onClick={reloadPreviousClip}>
          Previous Clip
        </button>
      ) : null}
    </div>
  )
}
